import React, { useEffect, useState, useContext } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useCategory } from '../../context/CategoryContext';
import CartContext from '../../context/CartContext';
import axios from 'axios';
import { BsFillCartCheckFill, BsFillCartPlusFill } from "react-icons/bs";
import { FaSpinner } from "react-icons/fa";
import "./CategoryPage.css";

const CategoryPage = () => {
  const { categoryName } = useParams();
  const { category, brand } = useCategory();
  const { cart, addToCart, removeFromCart } = useContext(CartContext);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const formatImageUrl = (url) => url ? url.replace("/media/", "/api/media/") : '';

  const formatPrice = (price) => {
    return Number(price || 0).toLocaleString("pt-AO", {
      style: "currency",
      currency: "AOA",
      minimumFractionDigits: 2,
    });
  };

  // Função para normalizar strings
  const normalize = str => (str || '').trim().toLowerCase();

  useEffect(() => {
    setIsLoading(true);

    axios.get('https://api.nwayami.com/api/produtos/')
      .then(response => {
        const allProducts = response.data;
        setProducts(allProducts);

        const activeFilter = category || brand || categoryName;

        // DEBUG opcional: veja as marcas disponíveis
        console.log("Filtro ativo:", activeFilter);
        console.log("Marcas encontradas:", [...new Set(allProducts.map(p => p.marca))]);

        const filtered = allProducts.filter(product =>
          normalize(product.categoria_nome) === normalize(activeFilter) ||
          normalize(product.marca) === normalize(activeFilter)
        );

        setFilteredProducts(filtered);
      })
      .catch(error => {
        console.error('Erro ao carregar os produtos:', error);
      })
      .finally(() => {
        setTimeout(() => setIsLoading(false), 1000); // Delay para suavizar carregamento
      });
  }, [category, brand, categoryName]);

  return (
    <div>
      <h1>{category || brand || categoryName} - Produtos</h1>

      {isLoading ? (
        <div className="loading-container">
          <FaSpinner className="spinner" size={30} />
        </div>
      ) : (
        <div className="product-list">
          {filteredProducts.length > 0 ? (
            filteredProducts.map(product => {
              const isInCart = cart.some(item => item.id === product.id);
              return (
                <div key={product.id} className="product-card">
                  <img src={formatImageUrl(product.imagem)} alt={product.descricao} />
                  <h3>{product.descricao}</h3>
                  <p className="card-text">Código: {product.codigo}</p>
                  <p>{formatPrice(product.preco_com_iva)}</p>

                  <button
                    className="cart-icon-button"
                    onClick={() => isInCart ? removeFromCart(product.id) : addToCart(product)}
                    title={isInCart ? "Remover do Carrinho" : "Adicionar ao Carrinho"}
                  >
                    {isInCart
                      ? <BsFillCartCheckFill size={24} color="green" />
                      : <BsFillCartPlusFill size={24} color="gray" />
                    }
                  </button>

                  <Link to={`/product/${product.id}`} className="btn btn-primary custom-btn">
                    Ver Detalhes
                  </Link>
                </div>
              );
            })
          ) : (
            <p>Não há produtos disponíveis nesta categoria ou marca.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default CategoryPage;
